import { Component, OnInit } from '@angular/core';
import { UnitsService } from 'src/app/services/units.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { AddunitComponent } from '../../units/addunit/addunit.component';
import { VillageService } from 'src/app/services/village.service';
import { AddVillageComponent } from '../add-village/add-village.component';
@Component({
  selector: 'app-mange-village',
  templateUrl: './mange-village.component.html',
  styleUrls: ['./mange-village.component.css']
})
export class MangeVillageComponent {

  typesArr:any = []
  villages_arr :any = []
  villageName = ''
  
  constructor(private rest: UnitsService,
    private route: Router,
    private valigeServ : VillageService,
    private main : MainService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.village_List()
    
  }



  // villages

  village_List(){
    this.valigeServ.villageList().subscribe((res:any) => {
      console.log(res)
      this.villages_arr = res
    })
  }

  add_Village() {
    const dialogRef = this.dialog.open(AddVillageComponent);

    dialogRef.afterClosed().subscribe((result :any) => {
      if(result){
        this.valigeServ.addVillge(result).subscribe((res:any) => {
          console.log(res)
          this.village_List()
        })
      }     
    });
  }

  VillageDetails(id: string) {
    
    this.route.navigate(['pages/village_details',id])
  }

  searchVillage(){
    this.valigeServ.searchVillage(this.villageName).subscribe((res:any) => {
      console.log(res)
      this.villages_arr = res
      if(res){
        this.villages_arr = res
      }
    },(err:any) => {
      this.villages_arr = []

    })
  }
}
